import axios from 'axios';
// import IdTokenVerifier from 'idtoken-verifier';
import {
    FETCH_USER,
    FETCH_SCREEN_HOME,
    FETCH_SCREEN_DONOR_PROFILE,
    FETCH_SCREEN_FAILED,
    PROJECT,
    PROJECTS,
    CHARITIES,
    CATEGORIES,
    PAYMENTS_SUCCESS,
    PAYMENTS_FAILED,
    FILTERS_UPDATE,
    FILTERS_FAILED,
    FILTERED_SEARCH_SUCCESS,
    FILTERED_SEARCH_FAILED,
    FAVOURITE_SUCCESS,
    FAVOURITE_FAILED,
    CONTINUEREF
} from './types';

import { API_BASE_URL } from '../environment';

export const updateContinueRef = (value) => async dispatch => {
    try {
        dispatch({ type: CONTINUEREF, payload: value });
        return value;
    } catch (error) {
        dispatch({ type: CONTINUEREF, payload: "/" });
        return error;
    }
};

export const fetchUser = () => async dispatch => {
    try {
        // retrieve access token from local storage and use as auth bearer token
        const access_token = await localStorage.getItem('access_token'); //token from Auth0
        // retrieve id token from local storage and use as tikki user token
        const id_token = await localStorage.getItem('id_token'); //token from Auth0

        const res = await axios.get(`${API_BASE_URL}/current_user`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${access_token}`,
                'tikkiuserid': `${id_token}`
            }
        });
        dispatch({ type: FETCH_USER, payload: res.data });

        // TODO - disabled 2018-04-22 for early access only users
        // var verifier = new IdTokenVerifier({
        //     // issuer: 'https://my.auth0.com/'
        //     // audience: 'xxxxxxx'
        // });
        // var res = verifier.decode(id_token);
        // dispatch({ type: FETCH_USER, payload: res.payload });

        return res;
    } catch (error) {
        dispatch({ type: FETCH_USER });
        return error;
    }
};

export const fetchScreenHome = () => async dispatch => {
    try {
        // retrieve access token from local storage and use as auth bearer token
        const access_token = await localStorage.getItem('access_token'); //token from Auth0
        // retrieve id token from local storage and use as tikki user token
        const id_token = await localStorage.getItem('id_token'); //token from Auth0

        const res = await axios.get(`${API_BASE_URL}/screens/home`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${access_token}`,
                'tikkiuserid': `${id_token}`
            }
        });
        dispatch({ type: FETCH_SCREEN_HOME, payload: res.data });
        /**
         * ensure update projects state is updated
         * maintains a unique list of projects and state
         */
        dispatch({ type: PROJECTS, payload: res.data.projectsFunding });
        dispatch({ type: PROJECTS, payload: res.data.projectsVolunteer });
        dispatch({ type: CATEGORIES, payload: res.data.categories });
        dispatch({ type: CHARITIES, payload: res.data.charities });
        return res;
    } catch (error) {
        dispatch({ type: FETCH_SCREEN_FAILED });
        return error;
    }
};

export const fetchScreenDonorProfile = () => async dispatch => {
    try {
        // retrieve access token from local storage and use as auth bearer token
        const access_token = await localStorage.getItem('access_token'); //token from Auth0
        // retrieve id token from local storage and use as tikki user token
        const id_token = await localStorage.getItem('id_token'); //token from Auth0

        const res = await axios.get(`${API_BASE_URL}/screens/donorprofile`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${access_token}`,
                'tikkiuserid': `${id_token}`
            }
        });

        dispatch({ type: FETCH_SCREEN_DONOR_PROFILE, payload: res.data });
        if (res.data.donations) {
            dispatch({ type: PROJECTS, payload: res.data.donations });
        }
        return res;
    } catch (error) {
        dispatch({ type: FETCH_SCREEN_FAILED });
        return error;
    }
};

export const fetchScreenProject = (projectId) => async dispatch => {
    try {
        // retrieve access token from local storage and use as auth bearer token
        const access_token = await localStorage.getItem('access_token'); //token from Auth0
        // retrieve id token from local storage and use as tikki user token
        const id_token = await localStorage.getItem('id_token'); //token from Auth0

        const res = await axios.get(`${API_BASE_URL}/screens/project?id=${projectId}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${access_token}`,
                'tikkiuserid': `${id_token}`
            }
        });
        dispatch({ type: PROJECTS, payload: res.data.projects });
        return res;
    } catch (error) {
        return error;
    }
};

export const fetchScreenCharity = (org) => async dispatch => {
    try {
        // retrieve access token from local storage and use as auth bearer token
        const access_token = await localStorage.getItem('access_token'); //token from Auth0
        // retrieve id token from local storage and use as tikki user token
        const id_token = await localStorage.getItem('id_token'); //token from Auth0

        const res = await axios.get(`${API_BASE_URL}/screens/charity?id=${org}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${access_token}`,
                'tikkiuserid': `${id_token}`
            }
        });
        dispatch({ type: CHARITIES, payload: res.data.charities });
        return res;
    } catch (error) {
        return error;
    }
};

export const fetchProject = (projectId) => async dispatch => {
    try {
        // retrieve access token from local storage and use as auth bearer token
        const access_token = await localStorage.getItem('access_token'); //token from Auth0
        // retrieve id token from local storage and use as tikki user token
        const id_token = await localStorage.getItem('id_token'); //token from Auth0

        const res = await axios.get(`${API_BASE_URL}/projects/${projectId}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${access_token}`,
                'tikkiuserid': `${id_token}`
            }
        });
        dispatch({ type: PROJECT, payload: res.data });
        return res;
    } catch (error) {
        return error;
    }
};

/**
 * payments using an offer
 */
export const createPayment = (offer, token) => async dispatch => {
    try {
        token.offer = offer; // inject the offer into the token object

        // retrieve access token from local storage and use as auth bearer token
        const access_token = await localStorage.getItem('access_token'); //token from Auth0
        // retrieve id token from local storage and use as tikki user token
        const id_token = await localStorage.getItem('id_token'); //token from Auth0

        const res = await axios.post(`${API_BASE_URL}/payments`, token, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${access_token}`,
                'tikkiuserid': `${id_token}`
            }
        });
        dispatch({ type: PROJECT, payload: res.data});
        return res;
    } catch (error) {
        dispatch({ type: PAYMENTS_FAILED, payload: null });
        return error;
    }
};

/**
 * filtered search
 */
export const filteredSearch = (values) => async dispatch => {
    try {
        // retrieve access token from local storage and use as auth bearer token
        const access_token = await localStorage.getItem('access_token'); //token from Auth0
        // retrieve id token from local storage and use as tikki user token
        const id_token = await localStorage.getItem('id_token'); //token from Auth0

        const res = await axios.post(`${API_BASE_URL}/search`, values, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${access_token}`,
                'tikkiuserid': `${id_token}`
            }
        });
        dispatch({ type: FILTERED_SEARCH_SUCCESS, payload: res.data });
        dispatch({ type: PROJECTS, payload: res.data.projects });
        return res;
    } catch (error) {
        dispatch({ type: FILTERED_SEARCH_FAILED, payload: null });
        return error;
    }
};

export const retrieveFavourite = () => async dispatch => {
    try {
        // retrieve access token from local storage and use as auth bearer token
        const access_token = await localStorage.getItem('access_token'); //token from Auth0
        // retrieve id token from local storage and use as tikki user token
        const id_token = await localStorage.getItem('id_token'); //token from Auth0

        const res = await axios.get(`${API_BASE_URL}/favourites`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${access_token}`,
                'tikkiuserid': `${id_token}`
            }
        });
        dispatch({ type: FAVOURITE_SUCCESS, payload: res.data });
        return res;
    } catch (error) {
        dispatch({ type: FAVOURITE_FAILED, payload: null });
        return error;
    }
};

export const addFavourite = (values) => async dispatch => {
    try {
        // retrieve access token from local storage and use as auth bearer token
        const access_token = await localStorage.getItem('access_token'); //token from Auth0
        // retrieve id token from local storage and use as tikki user token
        const id_token = await localStorage.getItem('id_token'); //token from Auth0

        const res = await axios.post(`${API_BASE_URL}/favourites`, values, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${access_token}`,
                'tikkiuserid': `${id_token}`
            }
        });
        dispatch({ type: FAVOURITE_SUCCESS, payload: res.data });
        return res;
    } catch (error) {
        dispatch({ type: FAVOURITE_FAILED, payload: null });
        return error;
    }
};

export const deleteFavourite = (values) => async dispatch => {
    try {
        // retrieve access token from local storage and use as auth bearer token
        const access_token = await localStorage.getItem('access_token'); //token from Auth0
        // retrieve id token from local storage and use as tikki user token
        const id_token = await localStorage.getItem('id_token'); //token from Auth0

        const res = await axios.delete(`${API_BASE_URL}/favourites/${values.projectId}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${access_token}`,
                'tikkiuserid': `${id_token}`
            }
        });
        dispatch({ type: FAVOURITE_SUCCESS, payload: res.data });
        return res;
    } catch (error) {
        dispatch({ type: FAVOURITE_FAILED, payload: null });
        return error;
    }
};

export const updateFilters = (values) => async dispatch => {
    try {
        dispatch({ type: FILTERS_UPDATE, payload: values });
        return values;
    } catch (error) {
        dispatch({ type: FILTERS_FAILED, payload: null });
        return error;
    }
};



// WEBPACK FOOTER //
// ./src/actions/index.js